/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vekn_Link_Modal_TitleInputs */



/**
* | output |
* | --- |
* | "Link VEKN ID" |
*
* @param {Vekn_Link_Modal_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const vekn_link_modal_title = /** @type {((inputs?: Vekn_Link_Modal_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vekn_Link_Modal_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Lier un VEKN ID")
	if (locale === "es") return /** @type {LocalizedString} */ ("Vincular ID VEKN")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Vincular VEKN ID")
	if (locale === "it") return /** @type {LocalizedString} */ ("Collega VEKN ID")
	return /** @type {LocalizedString} */ ("Link VEKN ID")
});